import React from "react";
import "./FooterAppDownloadModal.css";
import footer1 from '../../Footer/image/footer1.png'
import footer2 from '../../Footer/image/footer2.png'
import ReactDOM from "react-dom";

import { IoClose } from "react-icons/io5";

export default function FooterAppDownloadModal({ isOpen, onClose }) {
    if (!isOpen) return null;

    return ReactDOM.createPortal(
        <div className="f-download-modal-overlay">
            <div className="download-modal">
                <button className="f-download-modal-close-btn" onClick={onClose}>
                    <IoClose color="red" />
                </button>
                <h2>Download the App</h2>
                <p>Select your platform:</p>
                <div className="download-buttons">
                    <a className='download-btn' href="https://apps.apple.com/in/app/partywitty/id6478442502">
                        <img src={footer1} alt="" />
                    </a>
                    <a className='download-btn' href="https://play.google.com/store/apps/details?id=com.party.partywitty_guest">
                        <img src={footer2} alt="" />
                    </a>
                </div>
            </div>
        </div>,
        document.body
    );
}


